import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=68af26f3"
import script from "./CustomLink.vue?vue&type=script&lang=js"
export * from "./CustomLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68af26f3')) {
      api.createRecord('68af26f3', component.options)
    } else {
      api.reload('68af26f3', component.options)
    }
    module.hot.accept("./CustomLink.vue?vue&type=template&id=68af26f3", function () {
      api.rerender('68af26f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/CustomLink.vue"
export default component.exports